// Helpers compartidos por el editor de plantillas y el paso "actividades" del
// modal de nuevo proyecto.

// "1, 3; 4" -> [1, 3, 4]
export const parsePredecesoras = (texto) => {
  if (Array.isArray(texto)) return texto;
  return Array.from(
    new Set(
      String(texto || '')
        .split(/[,;\s/]+/)
        .map((t) => parseInt(t, 10))
        .filter((n) => Number.isFinite(n) && n > 0)
    )
  ).sort((a, b) => a - b);
};

export const formatPredecesoras = (lista) => (lista || []).join(', ');

// Renumera 1..n segun la posicion y reescribe las predecesoras con los numeros
// nuevos. Se usa despues de mover o borrar filas.
export const renumerar = (actividades) => {
  const mapa = new Map();
  actividades.forEach((a, i) => mapa.set(a.orden, i + 1));
  return actividades.map((a, i) => ({
    ...a,
    orden: i + 1,
    predecesoras: (a.predecesoras || [])
      .map((p) => mapa.get(p))
      .filter((p) => p && p !== i + 1),
  }));
};

// Borra una fila: sus sucesoras heredan sus predecesoras para no romper la cadena.
export const quitarActividad = (actividades, orden) => {
  const quitada = actividades.find((a) => a.orden === orden);
  const heredadas = quitada?.predecesoras || [];
  const resto = actividades
    .filter((a) => a.orden !== orden)
    .map((a) =>
      a.predecesoras?.includes(orden)
        ? {
            ...a,
            predecesoras: Array.from(
              new Set([...a.predecesoras.filter((p) => p !== orden), ...heredadas])
            ),
          }
        : a
    );
  return renumerar(resto);
};

export const moverActividad = (actividades, index, delta) => {
  const destino = index + delta;
  if (destino < 0 || destino >= actividades.length) return actividades;
  const copia = [...actividades];
  const [fila] = copia.splice(index, 1);
  copia.splice(destino, 0, fila);
  return renumerar(copia);
};

const MESES = ['ene.', 'feb.', 'mar.', 'abr.', 'may.', 'jun.', 'jul.', 'ago.', 'sept.', 'oct.', 'nov.', 'dic.'];

// '2026-10-01' -> '1 oct.' (sin zona horaria: la fecha es de calendario)
export const fechaCorta = (iso) => {
  if (!iso) return '';
  const [, m, d] = iso.split('-').map((x) => parseInt(x, 10));
  return `${d} ${MESES[m - 1]}`;
};

export const diasEntre = (a, b) => {
  if (!a || !b) return 0;
  const ms = Date.parse(`${b}T00:00:00`) - Date.parse(`${a}T00:00:00`);
  return Math.round(ms / 86400000);
};

export const duracionLegible = (dias) => {
  if (!dias) return 'sin duración';
  if (dias < 14) return `${dias} ${dias === 1 ? 'día' : 'días'}`;
  const semanas = Math.round(dias / 7);
  return `${semanas} semanas`;
};

export const hoyISO = () => {
  const d = new Date();
  const p = (n) => String(n).padStart(2, '0');
  return `${d.getFullYear()}-${p(d.getMonth() + 1)}-${p(d.getDate())}`;
};
